import client from "./client";

export const getCustomer = (id, params = {}) => {
    const response = client.get("/api/customers/" + id, { params: params });
    return response;
};

export const getCustomerBalance = (id) => {
    const response = client.get("/api/customers/" + id + "/balance");
    return response;
};

export const getCustomerSupportingDocuments = (id, params) => {
    const response = client.get("/api/customers/" + id + "/supporting-documents", { params: params});
    return response;
};

export const getCustomers = (params, opts = {}) => {
    const response = client.get("/api/customers", { params: params, cancelToken: opts.cancelToken });
    return response;
};

export const getCustomerAlerts = (id) => {
    const response = client.get("/api/customers/alerts/" + id);
    return response;
};

export const updateCustomer = (id, params) => {
    const response = client.put("/api/customers/" + id, params);
    return response;
};

export const createCustomer = (params) => {
    const response = client.post("/api/customers", params);
    return response;
};

export const addPaymentAgreementOnCustomer = (id, params) => {
    const response = client.post("/api/customers/" + id + "/payment-agreements", params);
    return response;
};

export const getCustomerByExternalId = (externalId) => {
    const response = client.get("/api/customers/by-external-id/" + externalId);
    return response;
};

export const getCustomerByField = (key, value, params) => {
    const response = client.get("/api/customers/by-field/" + key, { params: { value: value, ...params } });
    return response;
};

export const getCustomerQuotes = (id, params) => {
    const response = client.get("/api/customers/" + id + "/quotes", { params });
    return response;
};

export const getCustomerPolicies = (id, params) => {
    const response = client.get("/api/customers/" + id + "/policies", { params });
    return response;
};

export const sendEmailLoginLink = (email) => {
    const response = client.post("/api/send-login-by-email-link", { email });
    return response;
};

export const getGenderLabel = (gender) => {
    switch (gender?.toLowerCase()) {
        case "m":
            return "Mr";
        case "f":
            return "Mme";
        default:
            return "Mx.";
    }
};


export const getCustomerNotes = (id, params) => {
    const response = client.get("/api/customers/" + id + "/notes", { params });
    return response;
};

export const createCustomerNote = (id, params) => {
    const response = client.post("/api/customers/" + id + "/notes", params);
    return response;
}

export const getCustomerDocuments = (id, params) => {
    const response = client.get("/api/customers/" + id + "/documents", { params });
    return response;
};

export function uploadCustomerDocument(id, file, params = {}) {
    const formData = new FormData();

    formData.append("file", file);

    for (const [paramKey, paramValue] of Object.entries(params)) {
        formData.append(paramKey, paramValue);
    }

    const response = client.post(`/api/customers/${id}/documents`, formData);

    return response;
}

export function getCustomerPayments(id) {
    return client.get("/api/payments", { params: { customer_id: id } });
}

export function getPossibleDuplicates(id) {
    return client.get("/api/customers/" + id + "/possible-duplicates");
}